import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, forwardRef, useCallback, useContext, useImperativeHandle, useRef } from "react";
import ScrollIntoView from "../../../../../structures/others/scroll-into-view/index.js";
import contextBabylon from "../../../../../../context/index.js";
import useAutocomplete from "../../hooks/useAutocomplete.js";
import { boldText } from "../../utils/index.js";
import { HEADER_ICON, autocompleteLiterals } from "../../utils/autocomplete.js";
import * as S from "./styled.js";
export const AutocompleteMobile = /*#__PURE__*/ forwardRef((props, ref)=>{
    const refInputMobile = useRef(null);
    useImperativeHandle(ref, ()=>refInputMobile.current);
    const { Language  } = useContext(contextBabylon);
    const { disabled =false , literals ={} , persistentMenu , icon , onBlur , hideHeaderSuggestion =false  } = props;
    const refSuggestionMobile = useRef(null);
    const autocomplete = useAutocomplete(refSuggestionMobile, props);
    const { store , searchSuggestion , onChange , openSuggestions  } = autocomplete;
    const onSuggestionClick = useCallback((suggestion)=>()=>{
            onChange(suggestion);
        }, [
        onChange
    ]);
    const handleOnFocus = useCallback((e)=>{
        refInputMobile.current?.select();
        openSuggestions();
        e.target.select();
    }, [
        openSuggestions
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "Autocomplete",
        children: [
            /*#__PURE__*/ _jsx(S.AutocompleteInputModal, {
                ref: refInputMobile,
                value: store.value ?? '',
                onChange: searchSuggestion,
                onBlur: onBlur,
                icon: icon,
                onFocus: handleOnFocus,
                autoComplete: "off",
                autoFocus: true,
                disabled: disabled,
                "data-testid": "AutocompleteInputModal",
                isFocused: false
            }),
            (store.showSuggestions || persistentMenu) && /*#__PURE__*/ _jsx(S.TooltipMobile, {
                referenceElement: refInputMobile.current,
                isNegative: false,
                placement: "bottom-start",
                children: Children.toArray(store.suggestions?.map(({ key , suggestions  })=>/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            !hideHeaderSuggestion && /*#__PURE__*/ _jsxs(S.HeaderSuggestionMobile, {
                                "data-testid": "item-header-suggestion",
                                children: [
                                    /*#__PURE__*/ _jsx(S.IconWrapperMobile, {
                                        className: `nico-${HEADER_ICON[key]}`
                                    }),
                                    literals?.[key] ? literals?.[key] : autocompleteLiterals[Language.toLowerCase()][key]
                                ]
                            }),
                            Children.toArray(suggestions.map((suggestion)=>{
                                const isSelectSuggestion = store.selectingSuggestion?.id === suggestion.id;
                                return /*#__PURE__*/ _jsx(ScrollIntoView, {
                                    scrollToView: isSelectSuggestion,
                                    children: /*#__PURE__*/ _jsx(S.LabelSuggestionMobile, {
                                        $highlight: isSelectSuggestion,
                                        onClick: onSuggestionClick(suggestion),
                                        children: /*#__PURE__*/ _jsx("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: boldText(suggestion.text, store.query)
                                            }
                                        })
                                    })
                                });
                            }))
                        ]
                    })))
            })
        ]
    });
});
AutocompleteMobile.displayName = 'AutocompleteMobile';
export default AutocompleteMobile;

//# sourceMappingURL=index.js.map